import type React from "react";

import { Flexbox, type FlexboxProps } from "./Flexbox";

export type HorizontalFlexboxProps<T extends React.ElementType = "div"> = Omit<
  FlexboxProps<T>,
  "flexDirection"
>;

/**
 * A shorthand component for horizontal (row) flexbox layouts.
 * Sets flexDirection to "row" by default.
 */
export const HorizontalFlexbox = <T extends React.ElementType = "div">(
  props: HorizontalFlexboxProps<T>,
) => {
  return <Flexbox<T> {...(props as FlexboxProps<T>)} flexDirection="row" />;
};
